import React from 'react';
import { Icon, Loader, Message } from 'semantic-ui-react';
import { ClientContractsSummaryResponse } from '../../types/dtos';

interface ClientSummaryAccordionRowProps {
  loading: boolean;
  summary?: ClientContractsSummaryResponse;
  errorMessage?: string | null;
  isAdmin: boolean;
}

const cardStyle: React.CSSProperties = {
  border: '1px solid rgba(255, 255, 255, 0.2)',
  borderRadius: '10px',
  padding: '12px',
  background: 'rgba(255, 255, 255, 0.08)'
};

const getMeuTimLabel = (summary?: ClientContractsSummaryResponse) => {
  if (!summary) return 'Sem dados';
  if (summary.hasMeuTimCredentials) return 'Tem acesso';
  if (!summary.hasContract) return 'Sem contrato';
  if (summary.suspensionLines === 0) return 'Sem linhas de suspensão';
  return 'Não tem acesso';
};

const ClientSummaryAccordionRow: React.FC<ClientSummaryAccordionRowProps> = ({
  loading,
  summary,
  errorMessage,
  isAdmin
}) => {
  if (loading) {
    return (
      <div style={{ padding: '16px', textAlign: 'center' }}>
        <Loader active inline size="small" />
      </div>
    );
  }

  if (errorMessage) {
    return (
      <Message warning>
        <Message.Header>Resumo indisponível</Message.Header>
        <p>{errorMessage}</p>
      </Message>
    );
  }

  if (!summary) {
    return (
      <Message info>
        <Message.Header>Resumo ainda não carregado</Message.Header>
        <p>Tente atualizar a página para carregar os indicadores deste cliente.</p>
      </Message>
    );
  }

  return (
    <div style={{ display: 'grid', gridTemplateColumns: `repeat(${isAdmin ? 3 : 2}, minmax(0, 1fr))`, gap: '12px' }}>
      <div style={cardStyle}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px', fontWeight: 700 }}>
          <Icon name="file text outline" />
          Contratos
        </div>
        <p>Total: <strong>{summary.totalContracts}</strong></p>
        <p>Ativos: <strong>{summary.activeContracts}</strong></p>
        <p>Aguardando assinatura: <strong>{summary.awaitingSignatureContracts}</strong></p>
      </div>

      <div style={cardStyle}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px', fontWeight: 700 }}>
          <Icon name="pause circle" />
          Suspensões
        </div>
        <p>Linhas que requerem suspensão: <strong>{summary.suspensionLines}</strong></p>
      </div>

      {isAdmin && (
        <div style={cardStyle}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px', fontWeight: 700 }}>
            <Icon name="key" />
            Credenciais Meu TIM
          </div>
          <p>Com credenciais: <strong>{summary.suspensionLinesWithMeuTimCredentials ?? 0}</strong></p>
          <p>Status: <strong>{getMeuTimLabel(summary)}</strong></p>
        </div>
      )}
    </div>
  );
};

export default ClientSummaryAccordionRow;

